import React from 'react';
import clsx from 'clsx';
import styles from './onboarding-top-bar.scss';
import { useOnboardingContext } from '../../../onboarding.context';
import { ONBOARDING_STEPS } from '../../../types';
import { PeriodEndDropdown } from '../../top-bar/period-end-dropdown/period-end-dropdown';

const GREY_BLOB_HEIGHTS = {
  SMALL: '18px',
  MEDIUM: '23px',
  LARGE: '35px'
};

export const OnboardingTopBar = () => {
  const { currentStep, isNextEnabled } = useOnboardingContext();
  const showPeriodDropdown =
    currentStep >= ONBOARDING_STEPS.ADD_WIDGET || (currentStep === ONBOARDING_STEPS.ADD_TEMPLATE && isNextEnabled);

  return (
    <div className={styles.topBar}>
      <div className={clsx(styles.leftSide)}>
        <div
          className={styles.greyBlob}
          style={{ height: GREY_BLOB_HEIGHTS.SMALL, width: '78px', marginRight: '22px' }}
        />
        <div className={styles.greyBlob} style={{ height: GREY_BLOB_HEIGHTS.SMALL, width: '55px' }} />
      </div>
      <div className={clsx(styles.rightSide)} style={{ margin: 'auto 0' }}>
        {showPeriodDropdown ? (
          <div style={{ marginRight: '33px' }}>
            <PeriodEndDropdown />
          </div>
        ) : (
          <div
            className={styles.greyBlob}
            style={{ height: GREY_BLOB_HEIGHTS.LARGE, width: '245px', marginRight: '33px' }}
          />
        )}
        <div
          className={styles.greyBlob}
          style={{ height: GREY_BLOB_HEIGHTS.SMALL, width: '26px', marginRight: '26px' }}
        />
        <div
          className={styles.greyBlob}
          style={{ height: GREY_BLOB_HEIGHTS.MEDIUM, width: '55px', marginRight: '10px' }}
        />
        <div className={styles.greyBlob} style={{ height: GREY_BLOB_HEIGHTS.MEDIUM, width: '55px' }} />
      </div>
    </div>
  );
};
